module.exports = __webpack_public_path__ + "static/media/img-133.2b826922.jpg";